import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import EditIcon from '../../../../packages/common/shared-ui/src/icons/EditIcon';
import { formatWeek } from '../formatWeek';

// Original class: editIssueButton
const StyledEditIssueButton = styled(IconButton)(theme => ({
  '&.MuiButtonBase-root': {
    backgroundColor: '#6270D0',
  },
}));

const SpreadsheetMobileDetail = ({
  query,
  setQuery,
  formattedIssues,
  intl,
}) => {
  const currentIssue = formattedIssues[query.issue];
  const formattedWeek = formatWeek({
    startOfWeek: query.start,
    issue: currentIssue,
    intl,
  });
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('lg'),
  );

  const handleEditCurrentIssue = useCallback(() => {
    setQuery({ editIssue: currentIssue?.issueUniqueId, issue: null });
  }, [currentIssue, setQuery]);

  useEffect(() => {
    if (!formattedIssues[query.issue] || !isSmallScreen) {
      return setQuery({ issue: null });
    }
  }, [formattedIssues, isSmallScreen, query.issue, setQuery]);

  return (
    <Grid container direction='column'>
      <Grid
        container
        wrap='nowrap'
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          <Typography
            variant='h3'
            sx={{
              fontWeight: 700,
            }}
          >
            <FormattedMessage id='spreadsheet_table_issues' />
          </Typography>
          <Typography variant='h5'>
            {dayjs(query.start).format('DD MMMM YYYY')} -{' '}
            {dayjs(query.end).format('DD MMMM YYYY')}
          </Typography>
        </Box>
        <StyledEditIssueButton disableRipple onClick={handleEditCurrentIssue}>
          <EditIcon width='24' height='24' viewBox='0 0 24 24' />
        </StyledEditIssueButton>
      </Grid>
      <Grid
        container
        direction='column'
        sx={{
          padding: 4,
        }}
      >
        <Box
          sx={{
            marginBottom: 2.5,
          }}
        >
          <Typography variant='h6'>
            <FormattedMessage id='spreadsheet_table_project' />
          </Typography>
          <Typography variant='h4'>{currentIssue?.projectName}</Typography>
        </Box>
        <Box
          sx={{
            marginBottom: 2.5,
          }}
        >
          <Typography variant='h6'>
            <FormattedMessage id='spreadsheet_table_issues' />
          </Typography>
          <Typography variant='h4'>{currentIssue?.issueName}</Typography>
        </Box>
        {formattedWeek.map(day => {
          return (
            <Grid
              container
              wrap='nowrap'
              key={day.date}
              sx={{
                marginTop: 2.5,
              }}
            >
              <Box
                sx={{
                  marginRight: 7,
                  width: 46,
                }}
              >
                <Typography
                  variant='h6'
                  sx={{
                    color: '#111322',
                  }}
                >
                  {day.dayOfWeek}, {dayjs(day.date).format('DD.MM')}
                </Typography>
                <Typography variant='h4'>{day.hours}</Typography>
              </Box>
              <Box>
                <Typography
                  variant='h6'
                  sx={{
                    color: '#111322',
                  }}
                >
                  <FormattedMessage id='comment' />
                </Typography>
                <Typography variant='h4'>{day.comments}</Typography>
              </Box>
            </Grid>
          );
        })}
        <Box
          sx={{
            marginY: 2.5,
          }}
        >
          <Typography variant='h4'>
            <FormattedMessage id='spreadsheet_week_sum' />{' '}
            {formattedWeek.reduce((acc, day) => acc + day.hours, 0)}{' '}
            <FormattedMessage id='hour' />
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SpreadsheetMobileDetail;
